import { ReactNode } from 'react';
import { TableCell, TableRow, Typography } from '@mui/material';

import { UserPersonalToken } from '@apono/client-app-sdk';

import { DateTime } from '@common/utils/datetime';

interface TokensTableRowProps {
  token: UserPersonalToken;
  action?: ReactNode;
}

export default function TokensTableRow({ token, action }: TokensTableRowProps) {
  return (
    <TableRow>
      <TableCell width={300}>
        <Typography variant="body2">{token.name}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{token.masked_token}</Typography>
      </TableCell>
      <TableCell width={200}>
        <Typography variant="body2">{DateTime.fromUnix(Number(token.created_date)).readable}</Typography>
      </TableCell>
      <TableCell align="right" width={150}>
        {action}
      </TableCell>
    </TableRow>
  );
}
